import React from "react";
import { Form, Input } from "antd";
import {
  validateRequiredText,
  validatePhoneNumber,
  validateEmail,
} from "utils/insurance-validators";

const { TextArea } = Input;

export default function PersonalInfoSection() {
  return (
    <div>
      <h3>ข้อมูลผู้เอาประกันภัย (Personal Information)</h3>

      <Form.Item
        label="ชื่อ-นามสกุล (Full Name)"
        name="insuredFullName"
        rules={[
          {
            required: true,
            message: "กรุณากรอกชื่อ-นามสกุล",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 200)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกชื่อ-นามสกุลระหว่าง 1-200 ตัวอักษร")
              );
            },
          },
        ]}
      >
        <Input maxLength={200} placeholder="ชื่อ-นามสกุล" />
      </Form.Item>

      <Form.Item
        label="ที่อยู่ (Street Address)"
        name="insuredStreet"
        rules={[
          {
            required: true,
            message: "กรุณากรอกที่อยู่",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 255)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกที่อยู่ที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <TextArea rows={2} placeholder="ที่อยู่" />
      </Form.Item>

      <Form.Item
        label="เขต/อำเภอ (City/District)"
        name="insuredCity"
        rules={[
          {
            required: true,
            message: "กรุณากรอกเขต/อำเภอ",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 100)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกเขต/อำเภอที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <Input placeholder="เขต/อำเภอ" />
      </Form.Item>

      <Form.Item
        label="จังหวัด (Province/State)"
        name="insuredProvince"
        rules={[
          {
            required: true,
            message: "กรุณากรอกจังหวัด",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 100)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกจังหวัดที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <Input placeholder="จังหวัด" />
      </Form.Item>

      <Form.Item
        label="รหัสไปรษณีย์ (Postal Code)"
        name="insuredPostalCode"
        rules={[
          {
            required: true,
            message: "กรุณากรอกรหัสไปรษณีย์",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 10)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกรหัสไปรษณีย์ที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <Input placeholder="รหัสไปรษณีย์" />
      </Form.Item>

      <Form.Item
        label="โทรศัพท์ (Telephone)"
        name="insuredTelephone"
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validatePhoneNumber(value)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <Input maxLength={20} placeholder="โทรศัพท์" />
      </Form.Item>

      <Form.Item
        label="มือถือ (Mobile)"
        name="insuredMobile"
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validatePhoneNumber(value)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <Input maxLength={20} placeholder="มือถือ" />
      </Form.Item>

      <Form.Item
        label="อีเมล (Email)"
        name="insuredEmail"
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateEmail(value)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกอีเมลที่ถูกต้อง")
              );
            },
          },
        ]}
      >
        <Input maxLength={254} placeholder="อีเมล" />
      </Form.Item>

      <Form.Item
        label="อาชีพ (Occupation)"
        name="insuredOccupation"
        rules={[
          {
            required: true,
            message: "กรุณากรอกอาชีพ",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateRequiredText(value, 1, 100)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณากรอกอาชีพระหว่าง 1-100 ตัวอักษร")
              );
            },
          },
        ]}
      >
        <Input maxLength={100} placeholder="อาชีพ" />
      </Form.Item>
    </div>
  );
}
